import { axiosInstance } from ".";

const getPendingVerificationRequests = async (params) =>
  await axiosInstance.get("/verification_requests", {
    params: {
      ...params,
      is_pending: true,
    },
  });

const getVerificationRequestsHistory = async (params) =>
  await axiosInstance.get("/verification_requests", {
    params: {
      ...params,
      is_pending: false,
    },
  });

export { getPendingVerificationRequests, getVerificationRequestsHistory };
